
import styled from 'styled-components'

export const SuggestedContainer = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #ffffff;
  }
`

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
`

export const SparkleIcon = styled.span`
  color: #c6016b;
  font-size: 24px;
  margin-right: 8px;
`

export const SuggestedText = styled.div`
  display: flex;
  flex-direction: column;
`

export const SuggestedLabel = styled.span`
  color: #8c8c8c;
  font-size: 18px;
`

export const SuggestedValue = styled.span`
  color: #333333;
  font-size: 18px;
  font-weight: bold;
`

export const AcceptButton = styled.button`
  background-color: #c6016b;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 14px 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #b30059;
  }
`
